import { http } from '@/utils/http.util';

export default class languageService {
   async getLanguages() {
      return await http.get('/api/language').then((response) => {
         return response.data;
      });
   }
}
